<template>
    <div class="form__group--new" :class="{'form__group--validation-message-padding': validationMessagePadding}">
        <label class="form__label" :for="inputId">{{ label }}<em v-if="required" class="form__required-mark">*</em></label>
        <slot></slot>
        <ErrorMessage :name="name" :as="as" class="form__error"/>
    </div>
</template>

<script>
import {ErrorMessage, Field} from "vee-validate";

export default {
    name: "NewFormGroup",
    components: {Field, ErrorMessage},
    props: {
        inputId: {
            required: true,
            type: String,
        },
        name: {
            required: true,
            type: String,
        },
        label: {
            required: true,
            type: String,
        },
        as: {
            type: String,
            default: 'p',
        },
        required: {
            type: Boolean,
            required: false,
            default: false,
        },
        validationMessagePadding: {
            type: Boolean,
            default: false,
        }
    }
}
</script>